import ContactCtaSection from '../components/home/ContactCtaSection';
import HeroSection from '../components/home/HeroSection';
import OperationalProjectsSection from '../components/home/OperationalProjectsSection';
import TeamSection from '../components/home/TeamSection';

function Home() {
  return (
    <>
      <HeroSection />
      <OperationalProjectsSection />
      <TeamSection />
      <ContactCtaSection />
    </>
  );
}

export default Home;
